import React, { useState } from "react";
import { Card, CardHeader, Collapse, Container, Table } from "reactstrap";

export const Notas = ({ notas }) => {
    const [open, setOpen] = useState(false);

    const openCollapse = () => {
        setOpen(!open);
    };

    return (
        <div aria-multiselectable={true} className="card-collapse">
            <Card className="card-plain my-0">
                <CardHeader role="tab">
                    <div data-toggle="collapse" className="expanded c-pointer" onClick={openCollapse}>
                        {"Notas Aclaratorias"}&nbsp;&nbsp;
                        <i
                            className={
                                !open ? "now-ui-icons arrows-1_minimal-down" : "now-ui-icons arrows-1_minimal-up"
                            }
                        />
                    </div>
                </CardHeader>
                <Collapse isOpen={open}>
                    <Container className="text-center pl-0">
                        <div className={"table-responsive"}>
                            <Table className="adjusttd text-center">
                                <thead className="text-primary">
                                    <tr>
                                        <th>Item</th>
                                        <th>Num</th>
                                        <th>Texto</th>
                                        <th>Activo</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {notas.length === 0 ? (
                                        <React.Fragment>
                                            <tr>
                                                <td colSpan={5}>
                                                    <span>No hay información disponible.</span>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment>
                                            {notas.map((item, index) => (
                                                <tr key={item.cdAclaratorio}>
                                                    <td>
                                                        <span>{index + 1}</span>
                                                    </td>
                                                    <td className="text-left">
                                                        <span>{item.numAclaratorio}</span>
                                                    </td>
                                                    <td className="text-left">
                                                        {/*<SanitizedHTML html={item.txtAclaratorio}/>*/}
                                                    </td>
                                                    <td className="text-left">
                                                        <span>{item.activo ? "SI" : "NO"}</span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </React.Fragment>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </Container>
                </Collapse>
            </Card>
        </div>
    );
};
